<template>
  <div class="flash-sales-card">
    <div class="image">
      <img v-lazy="$cvWebpFn(flashSku.image)" :alt="flashSku.title">
      <div class="discount" v-if="flashSku.activityPrice !== flashSku.listPrice">
        {{ $getDiscount(flashSku.activityPrice, flashSku.listPrice) }}
      </div>
    </div>
    <div class="content">
      <div>
        <p class="p-title">{{ flashSku.title }}</p>
        <p class="price">
          <span class="sale-price">
            {{ $currencySymbol() }} {{ $toThousandsFn(flashSku.activityPrice) }}
          </span>
          <span class="source-price">
            {{ $currencySymbol() }} {{ $toThousandsFn(flashSku.listPrice) }}
          </span>
        </p>
      </div>

      <div class="status-btns">
        <div>
          <div class="stock-process" v-if="isActivate">
            <span class="process-val">{{ Math.ceil(stockProcess) }}% Left</span>
            <div class="inner-bar" :style="{ width: `${stockProcess}%` }"></div>
          </div>
        </div>
        <div v-if="status !== 4">
          <van-button v-if="!isActivate" type="primary" style="width: 80px;" size="small" color="#999">Waiting</van-button>
          <van-button v-else type="primary" style="width: 80px;" size="small">Grab It</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface IFlashSku {
  index: number;
  activityId: number;
  image: string;
  listPrice: number;
  salePrice: number;
  activityPrice: number;
  title: string;
  skuId: string;
  promiseStock: number;
  sold: number;
  inventory: number;
  inventoryStatus: number;
}

interface IProps{
  status: number;
  flashSku: IFlashSku;
}
const props = defineProps<IProps>()
const isActivate = computed<boolean>(() => props.status === 1)
const stockProcess = computed(() => {
  if(!props.flashSku) {
    return 100
  }

  return (props.flashSku.inventory / props.flashSku.promiseStock) * 100
})
</script>

<style lang="scss" scoped>
$imgSize: 200px;
.flash-sales-card{
  display: flex;
  align-items: center;
  height: $imgSize;
  margin: 20px 0;
  .image{
    width: $imgSize;
    min-width: $imgSize;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 10px;
    border: 1px solid #efefef;
    img{
      width: $imgSize;
      height: $imgSize;
      object-fit: contain;
    }
    .discount{
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      background: linear-gradient(135deg,#ffba00,#ff6c47 100%,#ff6047 0);
      border-radius: 8px;
      font-size: 22px;
      padding: 4px 8px;
    }
  }
  .content{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .p-title{
      text-shadow: 0 0 1px #333;
      @include ellipsisMultiline(2);
    }
    .price{
      margin-top: 15px;
      .sale-price{
        color: var(--main_color);
        font-weight: 600;
        font-size: 28px;
      }
      .source-price{
        font-size: 22px;
        color: #999;
        text-decoration: line-through;
        margin-left: 20px;
      }
    }
    .status-btns{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      $barHeight: 25px;
      .stock-process{
        background-color: #efefef;
        border-radius: $barHeight;
        height: $barHeight;
        width: 220px;
        overflow: hidden;
        position: relative;
        .process-val{
          position: absolute;
          left: 0;
          right: 0;
          left: 0;
          bottom: 0;
          height: $barHeight;
          color: #fff;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .inner-bar{
          width: 80%;
          height: 100%;
          border-radius: $barHeight;
          background: linear-gradient(to right, #ff582b, #ff2642);
        }
      }
    }
  }
}
</style>